import { EngineCSSRenderObject, Signal, THREE } from '@easytwin/runtime';

export type DrawPointMapType = 'hollow' | 'solid' | '' | 'rect-hollow';

export const DrawPointName = `engine-draw-point`;

export class DrawPointSprite extends THREE.Object3D {
  declare userData: { drawId: string; index: number };

  public type: DrawPointMapType = 'hollow';

  public cssObject: EngineCSSRenderObject = new EngineCSSRenderObject();

  public img: HTMLImageElement = document.createElement('img');

  public intersectBox = new THREE.Box3();

  private _canClick: boolean = true;

  private _rectangleDiv: HTMLDivElement = document.createElement('div');

  private _prentElement: HTMLElement | null = null;

  constructor(
    drawId: string = '', // 一般指代数字要素子要素的id
    id: string,
    // 这个位置指的是 sprite 的位置, 外层默认为0
    position: THREE.Vector3,
    scale: number = 12,
    type: DrawPointMapType = '',
    name: string = DrawPointName,
  ) {
    super();

    this._initRectangleDiv();

    this.uuid = id;
    this.name = name;

    const size = 10;

    this.img.style.position = 'absolute';
    this.cssObject.element.style.width = `${size}px`;
    this.cssObject.element.style.height = `${size}px`;
    this.img.style.width = `${size}px`;
    this.img.style.height = `${size}px`;

    // 射线返回的结果可能是 sprite
    this.cssObject.userData.drawId = drawId;
    this.userData.drawId = drawId;
    this.add(this.cssObject);
    this.cssObject.position.copy(position);
    this.cssObject.autoResize = false;
    this.cssObject.faceToCamera = true;
    this.cssObject.rotateX(Math.PI / 2);
    this.cssObject.scale.multiplyScalar(0.1);

    if (type === 'rect-hollow') {
      this.cssObject.element.appendChild(this._rectangleDiv);
    } else {
      this.cssObject.element.appendChild(this.img);
      this.setTexture(type);
    }
    this.type = type;

    this.intersectBox.setFromCenterAndSize(position, new THREE.Vector3(20, 0.5, 20));

    // this.sprite.material = new THREE.SpriteMaterial({
    //   sizeAttenuation: false,
    //   transparent: true,
    //   alphaTest: 0.2,
    //   depthTest: false,
    //   depthWrite: false,
    //   color: 'red'
    // });

    this.addEventListener('removed', () => {
      this.dispose();
    });
  }

  private _initRectangleDiv() {
    this._rectangleDiv.style.position = 'absolute';
    this._rectangleDiv.style.width = '6px';
    this._rectangleDiv.style.height = '6px';
    this._rectangleDiv.style.border = '1px solid #3A89FE ';
    this._rectangleDiv.style.backgroundColor = '#FFF';
  }

  public enableClick = (value: boolean) => {
    this._canClick = value;
  };

  public intersectObject(
    raycaster: THREE.Raycaster,
    clientX: number,
    clientY: number,
    intersects: Array<THREE.Intersection<THREE.Object3D<THREE.Object3DEventMap>>>,
  ): void {
    if (!this._canClick) return undefined;
    // if (this.cssObject.element.style.visibility === 'visible') {
    const rootRect = this.cssObject.element.getBoundingClientRect();

    if (
      clientX >= rootRect.left &&
      clientX <= rootRect.right &&
      clientY >= rootRect.top &&
      clientY <= rootRect.bottom
    ) {
      intersects.push({
        distance: 0,
        point: this.position.clone(),
        object: this,
      });
    }
    // }
  }

  public setVisible(visible: boolean) {
    this.visible = visible;

    this.cssObject.element.style.visibility = visible ? 'visible' : 'hidden';
  }

  public setTexture(type: DrawPointMapType): void {
    if (this.type === type) return;

    let url = '/image/drawHollow.png';
    switch (type) {
      case 'hollow':
        url = '/image/drawHollow.png';
        break;
      case 'solid':
        url = '/image/drawSolid.png';
        break;
      default:
        break;
    }

    this.img.src = url;
    // EasyTwinLoader.loadTexture(url).then((texture) => {
    //   texture.colorSpace = SRGBColorSpace;
    //   this.sprite.material.map = texture;
    //   this.sprite.material.needsUpdate = true;
    // });
    this.type = type;
  }

  public removeElement() {
    this._prentElement = this.cssObject.element.parentElement;
    this.dispose();
  }

  public appendElement() {
    if (this._prentElement) {
      this._prentElement.appendChild(this.cssObject.element);
    }
  }

  public dispose(): void {
    this.cssObject.element.remove();
  }
}
